var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.has_amount)?_c('CurrencyAmount',{attrs:{"amount":_vm.amount}}):_c('div',[_vm._v("\n    Cancelled Escrow "+_vm._s(_vm.sequence)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }